'use strict';

module.exports = {
	DATE: 'dd-MMMM-yyyy',
	TIME: 'H:mm',
	DEFAULT_STATE: 'home'
};
